import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from 'styles/app-styles';

const OverlaySpinner: FC = () => {

  function generateOverlaySpinnerContainer(){
    return styled.div`
      /* Overlay Box */
      .overlay {
        position: fixed;
        z-index: 999;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
      
      /* Overlay */
      .overlay:before {
        content: '';
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${Colors.darkGrey};
        opacity: 0.7;
      }

      /* Center Box */
      .center-box {
        position: fixed;
        margin: auto;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 220px;
        height: 200px;
        overflow: hidden;      
        text-align: center;
        border-radius: 5px;
        background-color: ${Colors.white}; // #dbe1e3 matches periwinkleGrey with opacity 0.3 if we want background to match overlay
      }

      /* Optional Text */
      p {
        padding-top: 10px;
        padding-right: 10px;
        padding-left: 10px;
        font-family: 'Roboto', sans-serif;
        font-size: 24px;
        color: ${Colors.blackPearl};
      }

      /* Spinner */
      .sk-folding-cube {
        margin: 60px auto;
        width: 70px;
        height: 70px;
        position: relative;
        -webkit-transform: rotateZ(45deg);
                transform: rotateZ(45deg);
      }
      
      .sk-folding-cube .sk-cube {
        float: left;
        width: 50%;
        height: 50%;
        position: relative;
        -webkit-transform: scale(1.1);
            -ms-transform: scale(1.1);
                transform: scale(1.1); 
      }
      .sk-folding-cube .sk-cube:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${Colors.denim};
        -webkit-animation: sk-foldCubeAngle 2.4s infinite linear both;
                animation: sk-foldCubeAngle 2.4s infinite linear both;
        -webkit-transform-origin: 100% 100%;
            -ms-transform-origin: 100% 100%;
                transform-origin: 100% 100%;
      }
      .sk-folding-cube .sk-cube2 {
        -webkit-transform: scale(1.1) rotateZ(90deg);
                transform: scale(1.1) rotateZ(90deg);
      }
      .sk-folding-cube .sk-cube3 {
        -webkit-transform: scale(1.1) rotateZ(180deg);
                transform: scale(1.1) rotateZ(180deg);
      }
      .sk-folding-cube .sk-cube4 {
        -webkit-transform: scale(1.1) rotateZ(270deg);
                transform: scale(1.1) rotateZ(270deg);
      }
      .sk-folding-cube .sk-cube2:before {
        -webkit-animation-delay: 0.3s;
                animation-delay: 0.3s;
      }
      .sk-folding-cube .sk-cube3:before {
        -webkit-animation-delay: 0.6s;
                animation-delay: 0.6s; 
      }
      .sk-folding-cube .sk-cube4:before {
        -webkit-animation-delay: 0.9s;
                animation-delay: 0.9s;
      }
      @-webkit-keyframes sk-foldCubeAngle {
        0%, 10% {
          -webkit-transform: perspective(140px) rotateX(-180deg);
                  transform: perspective(140px) rotateX(-180deg);
          opacity: 0; 
        } 25%, 75% {
          -webkit-transform: perspective(140px) rotateX(0deg);
                  transform: perspective(140px) rotateX(0deg);
          opacity: 1; 
        } 90%, 100% {
          -webkit-transform: perspective(140px) rotateY(180deg);
                  transform: perspective(140px) rotateY(180deg);
          opacity: 0; 
        } 
      }
      
      @keyframes sk-foldCubeAngle {
        0%, 10% {
          -webkit-transform: perspective(140px) rotateX(-180deg);
                  transform: perspective(140px) rotateX(-180deg);
          opacity: 0; 
        } 25%, 75% {
          -webkit-transform: perspective(140px) rotateX(0deg);
                  transform: perspective(140px) rotateX(0deg);
          opacity: 1; 
        } 90%, 100% {
          -webkit-transform: perspective(140px) rotateY(180deg);
                  transform: perspective(140px) rotateY(180deg);
          opacity: 0; 
        }
      }
    `;
  }

  const Container = generateOverlaySpinnerContainer();

  return (
    <Container>          
      <div className="overlay">
        <div className="center-box">
          <div className="sk-folding-cube">
            <div className="sk-cube1 sk-cube"></div>
            <div className="sk-cube2 sk-cube"></div>
            <div className="sk-cube4 sk-cube"></div>
            <div className="sk-cube3 sk-cube"></div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default OverlaySpinner